// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';
import { TAsyncAssignmentReq, TCreateAssignmentReq } from '../types/requests';

export function AssignmentController() {
  const getAssignment = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/catalog/assigns/`, {
      headers: getAuthHeaders(),
    });
  };

  const createAssignment = async <T>(data: TCreateAssignmentReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/api/v1/catalog/assigns/`, data, {
      headers: getAuthHeaders(),
    });
  };

  const syncAssignment = async <T>(data: TAsyncAssignmentReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/api/v1/catalog/assigns/sync`, data, {
      headers: getAuthHeaders(),
    });
  };

  return { getAssignment, createAssignment, syncAssignment };
}
